import React, { useState } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  BarController,
  LineElement,
  LineController,
  PointElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Chart } from 'react-chartjs-2';
import { Nav, Alert } from 'react-bootstrap';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  BarController,
  LineElement,
  LineController,
  PointElement,
  Title,
  Tooltip,
  Legend
);

const SalesPerformanceChart = ({ salesData }) => {
  const [period, setPeriod] = useState('week');
  const [error, setError] = useState(null);

  const selected = salesData?.[period] || { labels: [], orders: [], revenue: [] };

  const data = {
    labels: selected.labels,
    datasets: [
      {
        type: 'bar',
        label: 'Total Orders',
        data: selected.orders,
        backgroundColor: 'rgba(13, 202, 240, 0.7)',
        borderRadius: 4,
      },
      {
        type: 'line',
        label: 'Total Revenue (₹)',
        data: selected.revenue,
        borderColor: 'rgba(25, 135, 84, 1)',
        backgroundColor: 'rgba(25, 135, 84, 0.2)',
        tension: 0.4,
        fill: true,
        yAxisID: 'y1',
      },
    ],
  };

  const options = {
    responsive: true,
    interaction: { mode: 'index', intersect: false },
    plugins: {
      legend: { position: 'top' },
      title: {
        display: true,
        text: `Sales Performance - ${
          {
            today: 'Today',
            week: 'This Week',
            month: 'This Month',
            '3months': 'Last 3 Months',
            '6months': 'Last 6 Months',
          }[period]
        }`,
      },
    },
    scales: {
      y: {
        title: { display: true, text: 'Orders' },
        beginAtZero: true,
      },
      y1: {
        position: 'right',
        title: { display: true, text: 'Revenue (₹)' },
        beginAtZero: true,
        grid: { drawOnChartArea: false },
        ticks: { callback: (val) => `₹${val}` },
      },
    },
  };

  return (
    <div className="my-lg-5 my-4">
      <h4 className="mb-3">📊 Sales Performance</h4>

      <Nav variant="tabs" activeKey={period} onSelect={setPeriod} className="mb-4">
        {['today', 'week', 'month', '3months', '6months'].map((key) => (
          <Nav.Item key={key}>
            <Nav.Link eventKey={key}>
              {{
                today: 'Today',
                week: 'This Week',
                month: 'This Month',
                '3months': 'Last 3 Months',
                '6months': 'Last 6 Months',
              }[key]}
            </Nav.Link>
          </Nav.Item>
        ))}
      </Nav>

      {error && (
        <Alert variant="danger" className="mb-3">
          {error}
        </Alert>
      )}

      <Chart
        data={data}
        options={options}
        onError={(err) => {
          console.error('Chart render error:', err);
          setError('Failed to load chart. Please try again.');
        }}
      />
    </div>
  );
};

export default SalesPerformanceChart;
